export default __webpack_public_path__ + "static/media/1023.cb9cdddc.png";